import {
  AfterViewInit,
  Component, ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList, ViewChild,
  ViewChildren,
  ViewEncapsulation
} from "@angular/core";
import {animate, state, style, transition, trigger} from "@angular/animations";
import ICourse, {IPrice} from "ecoreps_shared/model/course";
import {Observable} from "rxjs";
import IUniversity from "ecoreps_shared/model/university";



interface Review {
  university: IUniversity,
  author: string
  text: string,
  time: any;
  courses: ICourse[],
  coursesString: string
}


@Component({
  selector: 'courses-carousel',
  templateUrl: './courses-carousel.component.html',
  styleUrls: ['./courses-carousel.component.scss']
})
export class CoursesCarouselComponent implements OnInit, AfterViewInit {

  @Input() public class: string = '';

  @Input() public courses: Observable<ICourse[]>;

  @ViewChildren('slicks') slicks: QueryList<ElementRef>;

  public carouselConfig = {
    "slidesToShow": 3,
    "slidesToScroll": 3,
    infinite: false,
    centerMode: false,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" style=""></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""></button>',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  };

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.slicks.forEach((slick) => {
      const el = (<any>slick).el.nativeElement;
      if (el.slick) {
        el.slick.refresh();
      }
    });
  }



}

